import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Sajnáljuk, hogy a cikk nem volt hasznos. Elmondaná, hogy mi volt a hiba?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Az általam keresett információ hiányzik',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Ténybeli hibák vannak',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Néhány kérdés nem világos',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Adj egy kis hátteret, és javítunk a cikken.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Küldje el a'
    }
  }
};
